
import { BUSY_CALLERS_CHANGE } from "./types";

const initialState = {
  busyCallers: [],
};
export function commonReducer(state = initialState, action) {
  switch (action.type) {
    case BUSY_CALLERS_CHANGE: {
      if (action.payload.isBusy === true) {
        // add key if not present
        if (
          state.busyCallers.filter((k) => k === action.payload.key).length === 0
        ) {
          return {
            ...state,
            busyCallers: [...state.busyCallers, action.payload.key],
          };
        }
        return state;
      } else {
        // remove key
        return {
          ...state,
          busyCallers: state.busyCallers.filter(
            (k) => k !== action.payload.key
          ),
        };
      }
    }

    default:
      return state;
  }
}


